/* WOLF BROS - Smart Search UI (instant results, quick filters, suggestions, animations). Needs wb-search-engine.js */
(function (root) {
  'use strict';
  var Engine = root.WBSearchEngine;
  if (!Engine || root.__wbSearchInit) return;
  root.__wbSearchInit = true;
  var buildIndex = Engine.buildIndex, search = Engine.search, baseNorm = Engine.baseNorm, titleCase = Engine.titleCase, imgUrl = Engine.imgUrl;
  var COLOR_FAMILIES = Engine.COLOR_FAMILIES, SIZE_ORDER = Engine.SIZE_ORDER;
  var doc = root.document;
  var CACHE_KEY = 'wbs:catalog:v4', RECENT_KEY = 'wbs:recent';
  var state = { index: null, loading: null, q: '', sort: 'newest', filters: { type: [], vendor: [], family: [], size: [] }, shown: 24, open: false, last: null };
  var els = {};
  var reduceMotion = root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function store(k, v) { try { if (v === undefined) return JSON.parse(root.localStorage.getItem(k) || 'null'); root.localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function sstore(k, v) { try { if (v === undefined) return JSON.parse(root.sessionStorage.getItem(k) || 'null'); root.sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(n) { return 'LE ' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }

  function slim(p) {
    return {
      id: p.id, title: p.title, handle: p.handle, vendor: p.vendor, product_type: p.product_type, tags: p.tags,
      published_at: p.published_at, created_at: p.created_at, options: p.options,
      images: (p.images || []).map(function (i) { return { src: i.src, variant_ids: i.variant_ids }; }),
      variants: p.variants.map(function (v) { return { id: v.id, option1: v.option1, option2: v.option2, option3: v.option3, available: v.available, price: v.price, compare_at_price: v.compare_at_price, featured_image: v.featured_image ? { src: v.featured_image.src } : null }; })
    };
  }

  function loadCatalog() {
    if (state.index) return Promise.resolve(state.index);
    if (state.loading) return state.loading;
    var cached = sstore(CACHE_KEY);
    if (cached && cached.t > Date.now() - 10 * 60 * 1000 && cached.p) {
      state.index = buildIndex(cached.p);
      return Promise.resolve(state.index);
    }
    var all = [];
    var page = function (n) {
      return fetch('/products.json?limit=250&page=' + n, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
        var ps = (j && j.products) || [];
        all = all.concat(ps.map(slim));
        return ps.length === 250 && n < 20 ? page(n + 1) : all;
      });
    };
    state.loading = page(1).then(function (ps) {
      sstore(CACHE_KEY, { t: Date.now(), p: ps });
      state.index = buildIndex(ps);
      return state.index;
    }).catch(function (err) { state.loading = null; throw err; });
    return state.loading;
  }

  function build(host) {
    var page = !!host;
    state.page = page;
    var wrap = doc.createElement('div');
    wrap.className = page ? 'wbs wbs--page is-open' : 'wbs';
    if (!page) {
      wrap.setAttribute('role', 'dialog');
      wrap.setAttribute('aria-modal', 'true');
      wrap.hidden = true;
    }
    wrap.setAttribute('aria-label', 'Search');
    wrap.innerHTML =
      (page ? '<h1 class="wbs-page-title">Search</h1>' : '<div class="wbs__backdrop" data-close></div>') +
      '<div class="wbs__panel">' +
        '<div class="wbs__bar">' +
          '<svg class="wbs__icon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>' +
          '<input class="wbs__input" type="search" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" enterkeyhint="search" dir="auto" placeholder="Search hoodies, jackets, brands… ابحث بالعربي" aria-label="Search">' +
          '<button class="wbs__clear" type="button" aria-label="Clear" hidden>&times;</button>' +
          (page ? '' : '<button class="wbs__close" type="button" data-close aria-label="Close">Close</button>') +
        '</div>' +
        '<div class="wbs__progress" aria-hidden="true"></div>' +
        '<div class="wbs__body" tabindex="-1">' +
          '<div class="wbs__filters" hidden></div>' +
          '<div class="wbs__status" role="status" aria-live="polite"></div>' +
          '<div class="wbs__content"></div>' +
        '</div>' +
      '</div>';
    if (page) host.parentNode.insertBefore(wrap, host); else doc.body.appendChild(wrap);
    els.root = wrap;
    els.input = wrap.querySelector('.wbs__input');
    els.clear = wrap.querySelector('.wbs__clear');
    els.filters = wrap.querySelector('.wbs__filters');
    els.status = wrap.querySelector('.wbs__status');
    els.content = wrap.querySelector('.wbs__content');
    els.body = wrap.querySelector('.wbs__body');

    wrap.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-close],[data-q],[data-filter],[data-sort],[data-more],[data-recent-del],[data-reset]');
      if (!t) return;
      if (t.hasAttribute('data-close')) { close(); return; }
      if (t.hasAttribute('data-recent-del')) { ev.stopPropagation(); var r = (store(RECENT_KEY) || []).filter(function (x) { return x !== t.getAttribute('data-recent-del'); }); store(RECENT_KEY, r); render(); return; }
      if (t.hasAttribute('data-q')) { els.input.value = t.getAttribute('data-q'); onInput(true); els.input.focus(); return; }
      if (t.hasAttribute('data-filter')) {
        var g = t.getAttribute('data-filter'), v = t.getAttribute('data-value'), arr = state.filters[g], i = arr.indexOf(v);
        if (i > -1) arr.splice(i, 1); else arr.push(v);
        state.shown = 24; render(); return;
      }
      if (t.hasAttribute('data-reset')) { state.filters = { type: [], vendor: [], family: [], size: [] }; state.shown = 24; render(); return; }
      if (t.hasAttribute('data-more')) { state.shown += 24; render(true); return; }
    });
    wrap.addEventListener('change', function (ev) {
      if (ev.target.matches('[data-sort]')) { state.sort = ev.target.value; state.shown = 24; render(); }
    });
    els.content.addEventListener('click', function (ev) {
      var a = ev.target.closest('a.wbs-card');
      if (a) saveRecent(state.q);
    });
    var timer;
    els.input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(onInput, 90); els.clear.hidden = !els.input.value; });
    els.input.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter') {
        ev.preventDefault(); clearTimeout(timer);
        if (ev.metaKey || ev.ctrlKey) { root.location.href = '/search?q=' + encodeURIComponent(els.input.value) + '&type=product'; return; }
        saveRecent(els.input.value);
        var qv = els.input.value.trim();
        if (!state.page) {      // header search: open the full results page
          if (qv) root.location.href = '/search?q=' + encodeURIComponent(qv) + '&type=product';
          return;
        }
        try { root.history.replaceState(null, '', '/search?q=' + encodeURIComponent(qv) + '&type=product'); } catch (e) {}
        els.clear.hidden = !els.input.value;
        state.enter = true;
        onInput(true);          // search right now (no waiting)
        els.input.blur();       // hide the phone keyboard
        showResults();
      } else if (ev.key === 'ArrowDown') {
        var c = els.content.querySelector('a.wbs-card, [data-q]'); if (c) { ev.preventDefault(); c.focus(); }
      }
    });
    els.clear.addEventListener('click', function () { els.input.value = ''; els.clear.hidden = true; onInput(true); els.input.focus(); });
    doc.addEventListener('keydown', function (ev) {
      if (!state.open) return;
      if (ev.key === 'Escape') { ev.preventDefault(); close(); }
      if (ev.key === 'Tab') {   // keep focus inside
        var f = els.root.querySelectorAll('input,button,select,a[href]');
        var list = Array.prototype.filter.call(f, function (x) { return x.offsetParent !== null; });
        if (!list.length) return;
        if (ev.shiftKey && doc.activeElement === list[0]) { ev.preventDefault(); list[list.length - 1].focus(); }
        else if (!ev.shiftKey && doc.activeElement === list[list.length - 1]) { ev.preventDefault(); list[0].focus(); }
      }
    });
  }

  // Enter: jump to the results (above the filters on small screens) with a small flash
  function showResults() {
    var go = function () {
      var target = els.content.querySelector('.wbs-head') || els.content;
      if (state.page) {
        var y = root.pageYOffset + target.getBoundingClientRect().top - 90;
        try { root.scrollTo({ top: Math.max(0, y), behavior: reduceMotion ? 'auto' : 'smooth' }); } catch (e) { root.scrollTo(0, y); }
      } else {
        var top = els.body.scrollTop + target.getBoundingClientRect().top - els.body.getBoundingClientRect().top - 8;
        try { els.body.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' }); } catch (e) { els.body.scrollTop = top; }
      }
      var grid = els.content.querySelector('.wbs-grid');
      if (grid) { grid.classList.remove('wbs-flash'); void grid.offsetWidth; grid.classList.add('wbs-flash'); }
    };
    if (state.index) requestAnimationFrame(go); else loadCatalog().then(function () { requestAnimationFrame(go); });
  }

  function saveRecent(q) {
    q = String(q || '').trim(); if (q.length < 2) return;
    var r = (store(RECENT_KEY) || []).filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    r.unshift(q); store(RECENT_KEY, r.slice(0, 6));
  }

  var lastFocus = null;
  function open(prefill) {
    if (state.page) { root.scrollTo({ top: 0, behavior: 'smooth' }); setTimeout(function () { els.input.focus(); }, 250); return; }
    if (!els.root) build();
    lastFocus = doc.activeElement;
    state.open = true;
    els.root.hidden = false;
    doc.documentElement.classList.add('wbs-lock');
    requestAnimationFrame(function () { els.root.classList.add('is-open'); });
    if (typeof prefill === 'string') els.input.value = prefill;
    els.clear.hidden = !els.input.value;
    setTimeout(function () { els.input.focus(); if (els.input.value) els.input.select(); }, reduceMotion ? 0 : 60);
    els.root.classList.add('is-loading');
    render();
    loadCatalog().then(function () { els.root.classList.remove('is-loading'); onInput(true); if (state.enter) showResults(); })
      .catch(function () { els.root.classList.remove('is-loading'); els.content.innerHTML = '<p class="wbs__empty">Couldn’t load products. <a href="/search">Open search page</a></p>'; });
  }

  function close() {
    if (!state.open) return;
    state.open = false;
    els.root.classList.remove('is-open');
    doc.documentElement.classList.remove('wbs-lock');
    setTimeout(function () { if (!state.open) els.root.hidden = true; }, reduceMotion ? 0 : 280);
    if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) {}
  }

  function onInput(force) {
    var q = els.input.value;
    if (!force && q === state.q) return;
    if (q.trim() !== state.q.trim()) { state.filters = { type: [], vendor: [], family: [], size: [] }; state.shown = 24; }
    state.q = q;
    render();
  }

  function facet(items, key, multi) {
    var m = {};
    items.forEach(function (e) {
      var vals = multi ? e[key] : [e[key]];
      (vals || []).forEach(function (v) { if (v) m[v] = (m[v] || 0) + 1; });
    });
    return m;
  }

  function applyFilters(items, except) {
    var f = state.filters;
    return items.filter(function (e) {
      if (except !== 'type' && f.type.length && f.type.indexOf(e.type) < 0) return false;
      if (except !== 'vendor' && f.vendor.length && f.vendor.indexOf(e.vendor) < 0) return false;
      if (except !== 'family' && f.family.length && f.family.indexOf(e.family) < 0) return false;
      if (except !== 'size' && f.size.length && !f.size.some(function (s) { return e.sizes.indexOf(s) > -1; })) return false;
      return true;
    });
  }

  function chips(group, label, counts, order) {
    var keys = Object.keys(counts);
    var active = state.filters[group];
    active.forEach(function (a) { if (keys.indexOf(a) < 0) { keys.push(a); counts[a] = 0; } });
    if (keys.length < 2 && !active.length) return '';
    if (order) keys.sort(function (a, b) { return order.indexOf(a) - order.indexOf(b); });
    else keys.sort(function (a, b) { return (counts[b] - counts[a]) || a.localeCompare(b); });
    var html = '<div class="wbs-fgroup"><span class="wbs-fgroup__label">' + label + '</span><div class="wbs-fgroup__chips">';
    keys.slice(0, 14).forEach(function (k) {
      var on = active.indexOf(k) > -1;
      var dot = group === 'family' ? '<i class="wbs-dot" style="background:' + (COLOR_FAMILIES[k] || '#777') + '"></i>' : '';
      var text = group === 'size' ? k.toUpperCase() : (group === 'family' ? titleCase(k) : k);
      html += '<button type="button" class="wbs-chip' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-filter="' + group + '" data-value="' + esc(k) + '">' + dot + esc(text) + '<small>' + counts[k] + '</small></button>';
    });
    return html + '</div></div>';
  }

  function highlight(text, terms) {
    var out = esc(text);
    if (!terms || !terms.length) return out;
    var words = [];
    terms.forEach(function (t) { t.alts.forEach(function (a) { if (a.length >= 2 && !/[؀-ۿ]/.test(a)) words.push(a.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')); }); });
    if (!words.length) return out;
    try { return out.replace(new RegExp('\\b(' + words.join('|') + ')', 'gi'), '<mark>$1</mark>'); } catch (e) { return out; }
  }

  function card(e, i, terms) {
    var delay = reduceMotion ? 0 : Math.min(i, 16) * 28;
    var badge = !e.available ? '<span class="wbs-badge wbs-badge--out">Sold out</span>' : (e.compare ? '<span class="wbs-badge">Sale</span>' : (Date.now() - e.created < 21 * 864e5 ? '<span class="wbs-badge wbs-badge--new">New</span>' : ''));
    return '<a class="wbs-card" href="' + esc(e.url) + '" style="--d:' + delay + 'ms">' +
      '<span class="wbs-card__media">' + (e.img ? '<img loading="lazy" src="' + esc(imgUrl(e.img, 360)) + '" srcset="' + esc(imgUrl(e.img, 240)) + ' 240w, ' + esc(imgUrl(e.img, 360)) + ' 360w, ' + esc(imgUrl(e.img, 540)) + ' 540w" sizes="(min-width: 990px) 200px, 45vw" alt="' + esc(e.title + (e.color ? ' – ' + e.color : '')) + '">' : '') + badge + '</span>' +
      '<span class="wbs-card__info">' +
        '<span class="wbs-card__vendor">' + esc(e.vendor) + '</span>' +
        '<span class="wbs-card__title">' + highlight(e.title, terms) + '</span>' +
        (e.color ? '<span class="wbs-card__color"><i class="wbs-dot" style="background:' + (COLOR_FAMILIES[e.family] || '#777') + '"></i>' + highlight(e.color, terms) + '</span>' : '') +
        '<span class="wbs-card__price">' + (e.compare ? '<s>' + money(e.compare) + '</s> ' : '') + money(e.price) + '</span>' +
      '</span></a>';
  }

  function renderSuggestions() {
    var recent = store(RECENT_KEY) || [];
    var html = '';
    if (recent.length) {
      html += '<section class="wbs-sec"><h3 class="wbs-sec__title">Recent searches</h3><div class="wbs-pills">' +
        recent.map(function (r) { return '<span class="wbs-pill wbs-pill--recent"><button type="button" data-q="' + esc(r) + '">' + esc(r) + '</button><button type="button" class="wbs-pill__x" aria-label="Remove" data-recent-del="' + esc(r) + '">&times;</button></span>'; }).join('') +
        '</div></section>';
    }
    if (state.index) {
      var types = facet(state.index.entries.filter(function (e) { return e.available; }), 'type');
      var tk = Object.keys(types).sort(function (a, b) { return types[b] - types[a]; }).slice(0, 8);
      var vend = facet(state.index.entries.filter(function (e) { return e.available; }), 'vendor');
      var vk = Object.keys(vend).sort(function (a, b) { return vend[b] - vend[a]; }).slice(0, 8);
      html += '<section class="wbs-sec"><h3 class="wbs-sec__title">Popular</h3><div class="wbs-pills">' +
        tk.map(function (t) { return '<button type="button" class="wbs-pill" data-q="' + esc(t) + '">' + esc(t) + '</button>'; }).join('') +
        '</div><div class="wbs-pills wbs-pills--brands">' +
        vk.map(function (t) { return '<button type="button" class="wbs-pill wbs-pill--ghost" data-q="' + esc(t) + '">' + esc(t) + '</button>'; }).join('') + '</div></section>';
      var newest = state.index.entries.filter(function (e) { return e.available; }).sort(function (a, b) { return b.created - a.created; });
      var seen = {}, picks = [];
      newest.forEach(function (e) { if (picks.length < 10 && !seen[e.pid]) { seen[e.pid] = 1; picks.push(e); } });
      html += '<section class="wbs-sec"><h3 class="wbs-sec__title">New arrivals</h3><div class="wbs-row">' + picks.map(function (e, i) { return card(e, i); }).join('') + '</div></section>';
    } else {
      html += '<section class="wbs-sec"><h3 class="wbs-sec__title">New arrivals</h3><div class="wbs-row">' + skeleton(6) + '</div></section>';
    }
    return html;
  }

  function skeleton(n) { var s = ''; for (var i = 0; i < n; i++) s += '<div class="wbs-card wbs-card--skel"><span class="wbs-card__media"></span><span class="wbs-skel-line"></span><span class="wbs-skel-line wbs-skel-line--short"></span></div>'; return s; }

  function render(append) {
    if (!els.root) return;
    var q = state.q.trim();
    if (!q) {
      els.filters.hidden = true; els.status.textContent = '';
      els.content.innerHTML = renderSuggestions();
      state.last = null;
      return;
    }
    if (!state.index) { els.filters.hidden = true; els.content.innerHTML = '<div class="wbs-grid">' + skeleton(8) + '</div>'; return; }
    var res = search(state.index, q, { sort: state.sort });
    state.last = res;
    var base = res.items;
    var items = applyFilters(base);
    // filter chips (each group counts with the other filters applied)
    var fh = '';
    fh += chips('type', 'Category', facet(applyFilters(base, 'type'), 'type'));
    fh += chips('family', 'Color', facet(applyFilters(base, 'family'), 'family'));
    fh += chips('size', 'Size', facet(applyFilters(base, 'size'), 'sizes', true), SIZE_ORDER.concat(Object.keys(facet(base, 'sizes', true))));
    fh += chips('vendor', 'Brand', facet(applyFilters(base, 'vendor'), 'vendor'));
    var activeCount = state.filters.type.length + state.filters.vendor.length + state.filters.family.length + state.filters.size.length;
    els.filters.innerHTML = fh ? fh + (activeCount ? '<button type="button" class="wbs-reset" data-reset>Clear filters (' + activeCount + ')</button>' : '') : '';
    els.filters.hidden = !fh;

    var info = [];
    if (res.parsed.sizes.length) info.push('size ' + res.parsed.sizes.map(function (s) { return s.toUpperCase(); }).join('/'));
    if (res.parsed.max !== null) info.push('under ' + money(res.parsed.max));
    if (res.parsed.min !== null) info.push('over ' + money(res.parsed.min));
    var head = '<div class="wbs-head"><p class="wbs-count"><b>' + items.length + '</b> result' + (items.length === 1 ? '' : 's') +
      (info.length ? ' <span class="wbs-tag">' + esc(info.join(' · ')) + '</span>' : '') +
      (res.corrected && res.corrected !== baseNorm(q) ? ' <span class="wbs-dym">for “' + esc(res.corrected) + '”</span>' : '') +
      (res.loose ? ' <span class="wbs-dym">closest matches</span>' : '') + '</p>' +
      '<label class="wbs-sort"><span>Sort</span><select data-sort>' +
        [['newest', 'Newest'], ['relevance', 'Best match'], ['price-asc', 'Price: low → high'], ['price-desc', 'Price: high → low']].map(function (o) { return '<option value="' + o[0] + '"' + (state.sort === o[0] ? ' selected' : '') + '>' + o[1] + '</option>'; }).join('') +
      '</select></label></div>';

    if (!items.length) {
      els.status.textContent = 'No results';
      els.content.innerHTML = head + '<div class="wbs__empty"><p>No results for “' + esc(q) + '”.</p><p>Try another word, or browse:</p></div>' + renderSuggestions().replace(/^[\s\S]*?(<section class="wbs-sec"><h3 class="wbs-sec__title">Popular)/, '$1');
      return;
    }
    els.status.textContent = items.length + ' results';
    var shown = items.slice(0, state.shown);
    var gridHtml = shown.map(function (e, i) { return card(e, append ? Math.max(0, i - (state.shown - 24)) : i, res.parsed.terms); }).join('');
    var more = items.length > state.shown ? '<button type="button" class="wbs-more" data-more>Show more (' + (items.length - state.shown) + ')</button>' : '';
    els.content.innerHTML = head + '<div class="wbs-grid">' + gridHtml + '</div>' + more;
    if (!append) els.body.scrollTop = 0;
  }

  // full results page: /search?q=... uses the same smart engine (Arabic, typos, colours, filters)
  function mountPage() {
    if (!/^\/search\/?$/.test(root.location.pathname)) return;
    var host = doc.querySelector('.template-search');
    if (!host) return;
    var q = '';
    try { q = new URLSearchParams(root.location.search).get('q') || ''; } catch (e) {}
    var css = doc.createElement('style');
    css.textContent = '.wbs.wbs--page{position:relative;inset:auto;z-index:1}' +
      '.wbs.wbs--page .wbs__panel{transform:none;opacity:1;max-height:none;height:auto;background:transparent;border:0;box-shadow:none;border-radius:0;max-width:var(--page-width,120rem);padding:0 1.5rem;overflow:visible}' +
      '.wbs.wbs--page .wbs-page-title{max-width:var(--page-width,120rem);margin:3.2rem auto 0;padding:0 1.5rem;text-align:center}' +
      '.wbs.wbs--page .wbs__bar{border:1px solid var(--wbs-line);border-radius:16px;margin:20px auto 6px;max-width:74rem;background:var(--wbs-panel)}' +
      '.wbs.wbs--page .wbs__body{overflow:visible;padding:16px 0 48px}' +
      '@media (min-width:750px){.wbs.wbs--page .wbs__panel,.wbs.wbs--page .wbs-page-title{padding:0 5rem}}';
    doc.head.appendChild(css);
    build(host);
    host.style.display = 'none';
    els.input.value = q;
    els.clear.hidden = !q;
    els.root.classList.add('is-loading');
    render();
    loadCatalog().then(function () { els.root.classList.remove('is-loading'); onInput(true); })
      .catch(function () { els.root.remove(); host.style.display = ''; state.page = false; els = {}; });
  }

  function isSearchTrigger(t) {
    return t.closest && t.closest('summary.header__icon--search, .header__search summary, a[href="/search"], a.header__icon--search, [data-wb-search]');
  }

  function init() {
    doc.addEventListener('click', function (ev) {
      var t = isSearchTrigger(ev.target);
      if (!t) return;
      ev.preventDefault(); ev.stopPropagation();
      var det = t.closest('details'); if (det) det.removeAttribute('open');
      open();
    }, true);
    doc.addEventListener('keydown', function (ev) {
      if (ev.key === '/' && !state.open && !/input|textarea|select/i.test((ev.target.tagName || '')) && !ev.target.isContentEditable) { ev.preventDefault(); open(); }
    });
    mountPage();
    var warm = function () { loadCatalog().catch(function () {}); };
    if ('requestIdleCallback' in root) root.requestIdleCallback(warm, { timeout: 4000 }); else setTimeout(warm, 2500);
    root.WBSearch = { open: open, close: close, engine: Engine, load: loadCatalog, state: state };
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
})(typeof window !== 'undefined' ? window : globalThis);
